import { render, staticRenderFns } from "./CrispScript.vue?vue&type=template&id=1343a429&lang=html"
import script from "./CrispScript.vue?vue&type=script&lang=js"
export * from "./CrispScript.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports